import { alpha, Box, styled, TextField, IconButton } from '@mui/material';

export const StyledTextField = styled(TextField)<{ width?: number }>(({ theme, width }) => ({
  '.MuiInputBase-root .MuiInputBase-input': {
    padding: theme.spacing(0.5),
    caretColor: theme.palette.primary.main,
    width: width ? `${width}px` : '',
    '&::placeholder': { opacity: 1, color: theme.palette.text.placeholder },
  },
  '.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderWidth: 1,
  },
  '.MuiInputBase-root.Mui-error:not(.Mui-disabled)': {
    '&, &:hover': {
      '.MuiInputBase-input': {
        caretColor: theme.palette.error.main,
      },
      '&:not(.Mui-disabled):before, .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main,
      },
    },
  },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.75),
  height: 32,
  width: 32,
}));

export const FocusWrapper = styled(Box)<{
  isPendingStatus: boolean;
  isActive: boolean;
  isHovered?: boolean;
}>(({ theme, isPendingStatus, isActive, isHovered = false }) => ({
  borderRadius: '8px',
  borderWidth: 1,
  borderStyle: isPendingStatus && !isActive ? 'dashed' : 'solid',
  borderColor: isActive
    ? theme.palette.primary.main
    : isPendingStatus
    ? theme.palette.border.hover
    : isHovered
    ? theme.palette.divider
    : 'transparent',
  boxShadow:
    isActive || isPendingStatus
      ? `0 0 0 4px ${
          isActive ? theme.palette.primary.focus : theme.palette.action.focus
        }, 0 1px 2px 0 ${alpha(theme.palette.divider, 0.05)}`
      : 'none',
  transition: 'box-shadow 0.3s, border-color 0.3s, border-style 0.3s',
}));
